import React from 'react';

import { ArrowRight2 } from 'iconsax-react';

import LinkButton from '@core/components/linkbutton/LinkButton';
import ColorBadge from '@core/components/colorbadge/ColorBadge';

import LinkedinIcon from 'assets/icons/linkedin-outline.svg';
import AvatarIcon from 'assets/icons/avatar-icon.svg';

import classes from './ExpertCard.module.scss';

/**
 * The experts list and, later, the career path and course pages all render the
 * same expert card, so it lives in @core rather than beside the experts page.
 *
 * The card is a plain div, not a Link: it already contains two independent
 * links (LinkedIn and the profile), and anchors cannot nest.
 */
export const expertProfileHref = (expert) =>
	`/experts/${expert?.unique_string_id}/${expert?.slug}`;

const ExpertCard = ({ expert }) => {
	if (!expert) return null;

	const fullName = [expert.first_name, expert.last_name].filter(Boolean).join(' ');

	return (
		<div className={classes['card']}>
			<div className={classes['avatar']}>
				{expert.image ? (
					<img src={expert.image} alt={fullName} />
				) : (
					<div className={classes['default-avatar']}>
						<AvatarIcon />
					</div>
				)}
			</div>

			<h3 className={classes['name']}>
				{fullName}
				{expert.linkedin_url && (
					<a
						className={classes['linkedin']}
						href={expert.linkedin_url}
						target='_blank'
						rel='noopener noreferrer'
						aria-label={`${fullName} on LinkedIn`}>
						<LinkedinIcon />
					</a>
				)}
			</h3>

			{expert.job_title && <p className={classes['job-title']}>{expert.job_title}</p>}

			{expert.years_of_experience > 0 && (
				<p className={classes['experience']}>{expert.years_of_experience} yrs exp</p>
			)}

			{expert.badges?.length > 0 && (
				<div className={classes['badges']}>
					{expert.badges.map((badge) => (
						<ColorBadge key={badge.id} color={badge.color} label={badge.name} />
					))}
				</div>
			)}

			<LinkButton
				className={classes['profile-button']}
				to={expertProfileHref(expert)}
				kind='secondary-light'>
				View Profile
				<ArrowRight2 size={16} />
			</LinkButton>
		</div>
	);
};

export default ExpertCard;
